import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=510b9815&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=510b9815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b9815",
  null
  
)

export default component.exports